import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import type { RaceFinishedEvent } from "@/types/Racing/RaceFinishedEvent";
import { hasValidRaceId, saveRaceResult } from "../model/raceResultSession";
import useRaceSSE from "../pages/RacePage/helper/useRaceSSE";

const noop = () => undefined;

const RaceResultListener = ({ account }: { account: string }) => {
  const navigate = useNavigate();
  const onFinish = useCallback((event: RaceFinishedEvent) => {
    if (!hasValidRaceId(event)) return;
    saveRaceResult(account, event);
    navigate(`/racing/result/${event.raceId}`, { state: { event } });
  }, [account, navigate]);

  useRaceSSE(account, onFinish, noop, noop);
  return null;
};

export default RaceResultListener;
